import { ColoredRange } from '../types/colored-range.js';
import { normalizeColoredRange } from './normalize-colored-ranges.js';

/**
 * Defines the items to render in a threshold legend
 * @internal
 */
export const buildLegendItemsFromRange = (ranges: ColoredRange[]) =>
  ranges.map((i) => normalizeColoredRange(i));
